// HOOKS
import { Routes, Route } from "react-router-dom";

// LAYOUTS
import HomeLayout from "./pages/home/layout.home.page";
import ModelLayout from "./pages/models/layout.models.page";
import ProductLayout from "./pages/products/layout.products.page";
import MakesLayout from "./pages/makes/layout.makes.page";

import "./App.css";

function App() {
  return (
    <Routes>
      <Route path="/" element={<HomeLayout />} />
      <Route path="/:category" element={<MakesLayout />} />
      <Route path="/:category/:make" element={<ModelLayout />} />
      <Route path="/:category/:make/:model" element={<ProductLayout />} />
    </Routes>
  );
}

export default App;
